import { useTranslation } from 'react-i18next'

import { OrderingMenu } from 'components/ordering/OrderingMenu'
import { useCurrentStore } from 'hooks'
import { useMemo } from 'react'

export const TableOrderingPage = () => {
  const { t } = useTranslation()

  const { store } = useCurrentStore()
  const tableInfo = store?.table_info

  const breadcrumbs = useMemo(() => {
    if (!tableInfo) return []
    return [
      { label: t(tableInfo.area_name) },
      { label: t(tableInfo.table_name) },
      { label: t('Ordering') },
    ]
  }, [tableInfo, t])

  return <OrderingMenu breadcrumbs={breadcrumbs} />
}
